import cloneDeep from 'lodash/cloneDeep'
import { initialState } from './index'
import { TemporaryCampaignRepository } from '@/models/CampaignOperation/TemporaryCampaignRepository'

export default {
  async FETCH_INCOMPLETE_CAMPAIGN_LIST({ commit }) {
    commit('SET_LOADING', true)
    const incompleteCampaignList = await TemporaryCampaignRepository.getIncomplete()
    commit('SET_INCOMPLETE_CAMPAIGN_LIST', incompleteCampaignList)
    commit('SET_INCOMPLETE_CAMPAIGN_COUNT', incompleteCampaignList.length)
    commit('SET_LOADING', false)
  },
  async SET_COMPLETE(_, { id }) {
    await TemporaryCampaignRepository.setComplete(id)
  },
  DELETE_CAMPAIGN({ commit }, { campaign, incompleteCampaingList }) {
    const index = incompleteCampaingList.indexOf(campaign)
    incompleteCampaingList.splice(index, 1)
    commit('SET_INCOMPLETE_CAMPAIGN_LIST', incompleteCampaingList)
  },
  INIT({ commit }) {
    const state = cloneDeep(initialState)
    commit('SET_INCOMPLETE_CAMPAIGN_LIST', state.incompleteCampaignList)
    commit('SET_INCOMPLETE_CAMPAIGN_COUNT', state.incompleteCampaignCount)
    commit('SET_LOADING', state.loading)
  },
}
